(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gta-pod-promo-bar"] && !Shopify.designMode) return;
  try {
    
class GtapCountdown extends HTMLElement {
  connectedCallback() {
    this.ends = parseInt(this.dataset.ends, 10);
    this.daily = this.dataset.daily === '1';
    const out = this.querySelector('[data-gtap-clock]');
    if (!this.ends || !out) return;
    const pad = (n) => (n < 10 ? '0' + n : '' + n);
    const tick = () => {
      let left = this.ends - Math.floor(Date.now() / 1000);
      // a daily cutoff rolls to tomorrow's, so cached HTML never shows a dead timer
      while (this.daily && left <= 0) { this.ends += 86400; left += 86400; }
      if (left <= 0) { this.hidden = true; clearInterval(this._t); return; }
      const d = Math.floor(left / 86400);
      const h = Math.floor((left % 86400) / 3600);
      const m = Math.floor((left % 3600) / 60);
      const s = left % 60;
      out.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
      this.hidden = false;
    };
    tick();
    this._t = setInterval(tick, 1000);
  }
  disconnectedCallback() { clearInterval(this._t); }
}
if (!customElements.get('gtap-countdown')) customElements.define('gtap-countdown', GtapCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
